import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AboutMission from "./pages/AboutMission";
import AboutTechnology from "./pages/AboutTechnology";
import Search from "./pages/Search";
import { initAOS } from "./lib/aos";
import BackgroundAnimation from "./components/BackgroundAnimation";

// Initialize animations
const initScrollAnimations = () => {
  document.documentElement.classList.add('dark');
  return () => {};
};

const queryClient = new QueryClient();

const App = () => {  
  useEffect(() => {
    const cleanup = initScrollAnimations();
    try { initAOS(); } catch (e) {}
    return cleanup;
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BackgroundAnimation color="#0ED3CF" intensity={0.3} />
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:projectId" element={<ProjectDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/mission" element={<AboutMission />} />
            <Route path="/about/technology" element={<AboutTechnology />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/search" element={<Search />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
